import LinkButton from "ds/components/Button/LinkButton";
import SystemMessage from "components/SystemMessage";
import { HourglassColored } from "components/icons/generated";
import { STATUS_PAGE_URL } from "shared/Maintenance/constants";
import useMaintenanceStore from "shared/Maintenance/store";
import MaintenanceMessage from "components/MaintenanceMessage";

const MaintenanceFullPage = () => {
  const message = useMaintenanceStore((state) => state.message);

  return (
    <SystemMessage
      icon={HourglassColored}
      title="Spacelift is undergoing maintenance"
      message={message && <MaintenanceMessage>{message}</MaintenanceMessage>}
    >
      <LinkButton
        variant="primary"
        size="medium"
        href={STATUS_PAGE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        View status page
      </LinkButton>
    </SystemMessage>
  );
};

export default MaintenanceFullPage;
